/**
 * @file 开始使用页入口
 * @author FengGuang(fengguang01@baidu.com)
 */
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'element-qsa-scope';
import 'location-origin';
import React from 'react';
import ReactDOM from 'react-dom';

import InstallRouter from './InstallRouter';
import './style.less';



ReactDOM.render(<InstallRouter />, document.getElementById('root'));


